export default function ScoreRing({ score, size = 120 }) {
  const r = (size / 2) - 8;
  const circ = 2 * Math.PI * r;
  const offset = circ - (score / 100) * circ;
  const color = score >= 70 ? '#4ecdc4' : score >= 45 ? '#ffd93d' : '#ff6b6b';

  return (
    <div style={{ width: size, height: size, position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <svg viewBox={`0 0 ${size} ${size}`} width={size} height={size} style={{ position: 'absolute', inset: 0, transform: 'rotate(-90deg)' }}>
        <circle fill="none" stroke="var(--border)" strokeWidth="6" cx={size/2} cy={size/2} r={r} />
        <circle fill="none" stroke={color} strokeWidth="6" strokeLinecap="round"
          cx={size/2} cy={size/2} r={r}
          style={{ strokeDasharray: circ, strokeDashoffset: offset, transition: 'stroke-dashoffset 1s ease' }} />
      </svg>
      <div style={{ textAlign: 'center', zIndex: 1 }}>
        <div style={{ fontFamily: 'Syne', fontSize: size * 0.22, fontWeight: 800, color, lineHeight: 1 }}>{score}</div>
        <div style={{ fontSize: size * 0.09, color: 'var(--muted)', letterSpacing: 1 }}>/100</div>
      </div>
    </div>
  );
}
